var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer has-background-grey-dark"},[_c('div',{staticClass:"content has-text-centered"},[_vm._v(" © "+_vm._s(_vm.yearRange())+" Myriatex. "+_vm._s(_vm.$t('footer_rights'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }